var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDate = function SvgDate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8h16v7.2a.8.8 0 0 1-.8.8H.8a.8.8 0 0 1-.8-.8V8zm12-6.4h3.2a.8.8 0 0 1 .8.8v4H0v-4a.8.8 0 0 1 .8-.8H4V0h1.6v1.6h4.8V0H12v1.6z",
    fillRule: "nonzero"
  })));
};
export default SvgDate;